import { Tooltip } from 'antd';
import React from 'react';
import { ExternalLink } from 'react-feather';
import { Link } from 'react-router-dom';
import Group from '../Group';

import './style.less';
import { TooltipPlacement } from 'antd/lib/tooltip';

interface Props {
  paths: { title?: string; url: string }[];
  disabled?: boolean;
  placement?: TooltipPlacement;
}

const RedirectIcon: React.FC<Props> = (props) => {
  return (
    <Tooltip
      overlayStyle={{ maxWidth: '700px' }}
      placement={props.placement}
      style={{
        pointerEvents: props.disabled ? 'none' : undefined,
      }}
      className="redirect-icon"
      title={props.paths.map((path, index) => (
        <Group
          key={index}
          position="between"
          style={{
            marginBottom: index + 1 < props.paths.length ? '8px' : 0,
          }}
        >
          <Link
            to={path.url}
            style={{
              pointerEvents: props.disabled ? 'none' : undefined,
            }}
            target="_blank"
            className="redirect-icon-link"
          >
            <span>{path.title}</span>
          </Link>
        </Group>
      ))}
    >
      <Link
        to={props.paths[0]?.url}
        style={{
          pointerEvents: props.disabled ? 'none' : undefined,
        }}
        target="_blank"
      >
        <ExternalLink style={{ width: 16, height: 16 }} />
      </Link>
    </Tooltip>
  );
};

export default RedirectIcon;
